import Actions from '../actions'
import { event, eventTypes } from '../consts/eventConsts'

// This function ensures that the user has granted the browser permission to use audio and video
// devices. If permission has not been granted, it will cause the browser to ask for permission
// for audio and video at the same time (as opposed to separate requests).
export const ensureMediaPermissions = dispatch => {
  return navigator.mediaDevices
    .enumerateDevices()
    .then(devices =>
      devices.every(device => !(device.deviceId && device.label))
    )
    .then(shouldAskForMediaPermissions => {
      if (shouldAskForMediaPermissions) {
        checkPermissions(dispatch)
      } else {
        changeMediaAccess(true, dispatch)
      }
    })
}

let event_sent = false
const checkPermissions = dispatch => {
  return navigator.mediaDevices
    .getUserMedia({ audio: true, video: true })
    .then(mediaStream => {
      changeMediaAccess(true, dispatch)
      return mediaStream.getTracks().forEach(track => track.stop())
    })
    .catch(() => {
      changeMediaAccess(false, dispatch)
    })
}

const changeMediaAccess = (isAllowed, dispatch) => {
  dispatch(Actions.createAction(Actions.MEDIA_ACCESS_ALLOWED, isAllowed))
  if (!event_sent) {
    event_sent = true
    dispatch(
      Actions.createAction(Actions.ANALYTICS_EVENT_FIRED, {
        type: eventTypes.formEvent,
        eventName: event.formEvent.submit,
        data: {
          permissions: isAllowed,
        },
        element: 'Camera Permissions',
      })
    )
  }
}
